export default __webpack_public_path__ + "static/pricing-b827c3393e256afe68289d0e73a08202.png";